import { useEffect, useRef } from 'react';

/*
 * When the control that held focus inside a tab unmounts (Close preview, a finished run's Stop, the
 * blocked panel's buttons, "Load older" on the last page), focus falls to <body>; send it to the
 * tab's heading instead. Returns the onFocus handler for the tab's root element.
 */
export const useHeadingRefocus = (heading_ref) => {
  const last = useRef(null);

  // No deps: every render may be the one that removed the focused control.
  useEffect(() => {
    const el = last.current;
    if (!el || el.isConnected) return;
    last.current = null;
    // Focus the operator already moved somewhere real is left alone.
    const active = document.activeElement;
    if (active && active !== document.body) return;
    if (heading_ref.current) heading_ref.current.focus({ preventScroll: true });
  });

  return (e) => {
    last.current = e.target;
  };
};
